import {
  Column,
  PageMainContent,
  PageWidgetContainer,
  Row,
  Typography,
} from '@/components'
import { Breakpoint } from '@/enums'
import { themeBreakpointDown, themeBreakpointUp } from '@/utils'
import styled from 'styled-components'
import { ifProp, prop } from 'styled-tools'

export const DashboardMainContent = styled(PageMainContent)`
  padding: 0;
  display: flex;
  flex-direction: column;
`

export const Container = styled(Row)`
  height: 100%;
  padding: 24px 32px;
  gap: 24px;
  background-color: ${(props) => props.theme.color.b10};

  ${themeBreakpointDown(Breakpoint.sm)} {
    padding: 16px;
  }
`

export const LocationCardContent = styled(Row)`
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const DashboardCompanyCard = styled(Column)<{
  isHeadquarters: boolean
}>`
  gap: 8px;
  width: 100%;
  overflow: hidden;
`

export const DashboardCompanyCardHeader = styled(Column)`
  gap: 8px;
  margin-bottom: ${ifProp('isHeadquarters', '8px', 0)};
  > h6 {
    margin-bottom: ${ifProp('isHeadquarters', 0, '8px')};
  }
`

export const DashboardCompanyCardItem = styled.button<{
  isHeadquarters: boolean
}>`
  padding: 16px;
  background-color: ${(props) =>
    props.isHeadquarters ? props.theme.color.info4 : props.theme.color.b0};
  border: 1px solid ${(props) => props.theme.color.info3};
  border-radius: 12px;
  gap: 24px;

  > * {
    width: 100%;
  }
`

export const HeadquartersColumn = styled(Column)`
  gap: 16px;
`
export const CompaniesColumn = styled(Column)`
  gap: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.color.b0};
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.b30};

  > h5 {
    margin-bottom: 0;
  }
`

export const EmptyCompanySearchContainer = styled(Column)`
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px 0;
  text-align: center;

  > button svg {
    margin-left: 4px;

    > path {
      stroke: ${(props) => props.theme.color.electric500};
    }
  }
`

export const HeaderSection = styled(Column)`
  gap: 24px;
`

export const DashboardHeader = styled(Row)`
  height: 20vw;
  width: 100%;
  min-height: 140px;
  padding: 24px 32px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%), url(${prop(
    'logoUrl',
  )});,
    lightgray 50%;
  background-size: cover;
  background-position: center;
  justify-content: space-between;
  align-items: center;

  > div:first-child {
    align-self: end;
  }

  ${themeBreakpointDown(Breakpoint.sm)} {
    padding: 16px;
  }

  ${themeBreakpointUp(Breakpoint['3xl'])} {
    height: 10vw;
}
`

export const HeaderTextContainer = styled(Column)`
  justify-content: flex-end;
  overflow: hidden;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const HeaderLogoWrapper = styled(Row)`
  width: 6vw;
  height: 6vw;
  min-height: 64px;
  min-width: 64px;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: ${(props) => props.theme.color.b0};
  border-radius: 12px;
  aspect-ratio: 1/1;
  margin-right: 16px;
  > img {
    width: 80%;
    height: 80%;
  }

  ${themeBreakpointDown(Breakpoint.md)} {
    margin-right: 0;
  }

  ${themeBreakpointUp(Breakpoint['3xl'])} {
    height: 4vw;
    width: 4vw;
  }
`

export const MiddleSectionColumn = styled(Column)`
  flex: 1;
  gap: 20px;
`

export const StyledPageWidgetContainer = styled(PageWidgetContainer)`
  padding-right: 0;
`

export const HeaderAndSearchContainer = styled(Row)`
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  ${themeBreakpointDown(Breakpoint.sm)} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const HeaderText = styled(Typography)`
  flex: 1;
  hyphens: none;
`

export const SearchInputContainer = styled(Row)`
  flex: 1;
`

export const LocationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  ${themeBreakpointDown(Breakpoint.md)} {
    grid-template-columns: repeat(1, 1fr);
  }
`
